const getBaseUrl = (baseUrl) => {
  if (baseUrl && typeof baseUrl === 'string' && baseUrl.trim() !== '') {
    return baseUrl.trim();
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }

  return '';
};

export const buildPublicClippingUrl = (clippingId, baseUrl = process.env.REACT_APP_CLIENT_URL) => {
  const normalizedBaseUrl = getBaseUrl(baseUrl).replace(/\/+$/, '');
  return `${normalizedBaseUrl}/visualizarNoticiaNewsletter/${clippingId}`;
};
